import React from 'react'
import { Button, Container, Table } from 'semantic-ui-react'

import openDescription from '../../../assets/images/eye-fuchsia.png'
import closedDescription from '../../../assets/images/eye-gray.png'
import openNotes from '../../../assets/images/notes-fuchsia.png'
import closedNotes from '../../../assets/images/notes-gray.png'
import Bubble from '../bubble'
import { tr } from '../../../helpers/languages'

const Exercises = (props) => {
    return props.exercises ? (
        <Container className='exercises'>
            <Table fixed singleLine>
                <Table.Body>
                    {
                        props.exercises.map((exercise, index) => {
                            const status = exercise.status === 'plain_counter' ? `${exercise.completed} ${tr('COMPLETED')}`
                                : tr(exercise.status.toUpperCase())
                            return (
                                <Table.Row
                                    key={`exercise${exercise.id}`}
                                    className={index === props.exercises.length - 1 ? 'last' : ''}
                                >
                                    <Table.Cell className='name'>
                                        {
                                            exercise.id !== 'moodj' && (
                                                <span>{exercise.title}</span>
                                            )
                                        }
                                        {
                                            exercise.id === 'moodj' && (
                                                <Button
                                                    className='undercover-link'
                                                    onClick={(_e) => { props.onClickOnMoodJournals() }}
                                                >
                                                    {tr('MOOD_JOURNALS')}
                                                </Button>
                                            )
                                        }
                                        {
                                            exercise.note && (
                                                <Bubble
                                                    name='notes'
                                                    position='top center'
                                                    openImage={openNotes}
                                                    closedImage={closedNotes}
                                                    title={tr('NOTE')}
                                                    text={exercise.note}
                                                />
                                            )
                                        }
                                        {
                                            exercise.description && (
                                                <Bubble
                                                    name='description'
                                                    position='top center'
                                                    openImage={openDescription}
                                                    closedImage={closedDescription}
                                                    title={tr('DESCRIPTION')}
                                                    text={exercise.description}
                                                />
                                            )
                                        }
                                    </Table.Cell>
                                    <Table.Cell className={`status ${exercise.status}`}>
                                        {status}
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })
                    }
                </Table.Body>
            </Table>
        </Container>
    ) : null
}

export default Exercises



// WEBPACK FOOTER //
// ./src/components/common/completed-exercises/exercises.js